import * as React from "react"
import { Button } from "./button"
import { cn } from "../../lib/utils"

const FilterButtons = React.forwardRef(({
  options,
  selectedValue,
  onChange,
  className,
  ...props
}, ref) => {
  return (
    <div ref={ref} className={cn("flex gap-2", className)} {...props}>
      {options.map((option) => (
        <Button
          key={option.value}
          variant="ghost"
          className={cn(
            "px-2 hover:bg-transparent",
            selectedValue === option.value
              ? "underline decoration-2 underline-offset-2"
              : "hover:underline hover:decoration-1 hover:underline-offset-2"
          )}
          onClick={() => onChange(option.value)}
          type="button"
        >
          {option.label}
        </Button>
      ))}
    </div>
  )
})

FilterButtons.displayName = "FilterButtons"

export { FilterButtons }